import { useTranslation } from 'next-i18next';
import { ThemeContext } from '@forma/forma-ui-kit';

import styles from './steps.module.css';
import classNames from 'classnames';
import { useContext } from 'react';

const Steps = ({ steps, activePosition = 0 }) => {
  const { t } = useTranslation();

  const { viewport } = useContext(ThemeContext);
  const isPhone = viewport === 'phone';

  const textElementsForTranslation = ['choose_a_template', 'fill_the_details'];
  return (
    <>
      <div className={styles.steps}>
        {steps.map((elem, index) => (
          <div
            className={classNames(
              styles.step,
              activePosition >= index && styles.active
            )}
            key={index}
          >
            <span>{index + 1}</span>
            {!isPhone && elem}
          </div>
        ))}
      </div>
      {isPhone && activePosition !== 2 && (
        <div className={styles.mobileText}>
          {t(textElementsForTranslation[activePosition])}
        </div>
      )}
    </>
  );
};

export default Steps;
